import React, { useContext, useEffect, useState } from 'react'
import styles from './Form.module.sass'
import Action from './Action'
import { useMediaQuery } from 'react-responsive'
import Icon from '../../../../../components/Icon'
import { useSelector } from 'react-redux'
import OpenClosePannel from 'screens/Exchange/Futures/Actions/OpenClosePannel'
import { useTranslation } from 'react-i18next'
import { usePricingMonitor } from 'hooks'
import SocketContext from 'context/context'

const Form = ({
  contentBuy,
  contentSell,
  conditionalOrOCO,
  limit,
  priceBuy,
  amountBuy,
  totalPriceBuy,
  priceSell,
  amountSell,
  totalPriceSell,
  stop,
  triggerPrice,
  visible,
  setValue,
  handleChange,
  takeProfit,
  stopLoss,
  orders,
  type,
  selectedMarket,
  pricePrecision,
  amountPrecision,
}) => {
  const { t } = useTranslation()
  const [isBuy, setIsBuy] = useState(true)
  const isTablet = useMediaQuery({ query: '(max-width: 1023px)' })
  const [baseAsset, setBaseAsset] = useState('')
  const [quoteAsset, setQuoteAsset] = useState('')
  const { state } = useContext(SocketContext)
  const { klines } = state
  const pricingData = usePricingMonitor(klines?.symbol || "ETH/USDT")


  useEffect(() => {
    if (selectedMarket){
      const [base, quote] =  selectedMarket?.replace('/', '')?.split('-') || []
      setBaseAsset(base)
      setQuoteAsset(quote)
    }
  }, [selectedMarket, baseAsset, quoteAsset])

  const { clientData } = useSelector((state) => state?.Profile)

  const { selectedLayout } = useSelector(
    (state) => state?.crypto?.layoutReducer,
  )

  const handleChangeOrderType = (val) => {
    setIsBuy(val)
  }

  
  return (
    <div className={styles.form}>
      {isTablet && selectedLayout !== 'Standerd' ? (
        <>
          {visible ? (
            <>
              <div className={styles.head}>
                <div className={styles.title}>Place order</div>
                <button
                  type='button'
                  className={styles.close}
                  onClick={() => setValue(false)}
                >
                  <Icon name="close-circle" size="24" />
                </button>
              </div>
              <Action
                title={`Buy ${baseAsset}`}
                content={contentBuy}
                price={priceBuy}
                totalPrice={totalPriceBuy}
                amount={amountBuy}
                priceSymbol={quoteAsset}
                amountSymbol={baseAsset}
                conditionalOrOCO={conditionalOrOCO}
                contentSell={contentSell}
                triggerPrice={triggerPrice}
                stop={stop}
                limit={limit}
                classButton="button-green"
                buttonText={clientData?._id ? "Buy" : "Sign In"}
                handleChange={handleChange}
                takeProfit={takeProfit}
                stopLoss={stopLoss}
                orders={orders}
                type={type}
                actionType='buy'
                pricePrecision={pricePrecision}
                amountPrecision={amountPrecision}
                currentPrice={pricingData?.currentPrice}
                klinesSymbol={klines?.symbol}
              />
            </>
          ) : (
            <>
              <div className={styles.head}>
                <div className={styles.title}>Place order</div>
                <button
                  type='button'
                  className={styles.close}
                  onClick={() => setValue(false)}
                >
                  <Icon name="close-circle" size="24" />
                </button>
              </div>
              <Action
                title={`Sell ${baseAsset}`}
                content={contentSell}
                triggerPrice={triggerPrice}
                price={priceSell}
                totalPrice={totalPriceSell}
                amount={amountSell}
                priceSymbol={quoteAsset}
                amountSymbol={baseAsset}
                conditionalOrOCO={conditionalOrOCO}
                stop={stop}
                limit={limit}
                classButton="button-red"
                buttonText={clientData?._id ? "Sell" : "Sign In"}
                handleChange={handleChange}
                orders={orders}
                type={type}
                actionType='sell'
                pricePrecision={pricePrecision}
                amountPrecision={amountPrecision}
                currentPrice={pricingData?.currentPrice}
                klinesSymbol={klines?.symbol}


              />
            </>
          )}
        </>
      ) : selectedLayout !== 'Standard' ? (
        <div>
          <div className={styles.row}>
            <div className={styles.panelContainer}>
              <OpenClosePannel
                label1={'Buy'}
                label2={'Sell'}
                handleChange={handleChangeOrderType}
              />
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.panelCol}>
              <div className={styles.advancePanelActionContainer}>
                {isBuy ? (
                  <Action
                    title={`Buy ${baseAsset}`}
                    priceSymbol={quoteAsset}
                    amountSymbol={baseAsset}
                    triggerPrice={triggerPrice}
                    conditionalOrOCO={conditionalOrOCO}
                    stop={stop}
                    limit={limit}
                    classButton="button-green"
                    buttonText={clientData?._id ? "Buy" : "Sign In"}
                    takeProfit={takeProfit}
                    stopLoss={stopLoss}
                    orders={orders}
                    type={type}
                    actionType='buy'
                    pricePrecision={pricePrecision}
                    amountPrecision={amountPrecision}
                    currentPrice={pricingData?.currentPrice}
                        klinesSymbol={klines?.symbol}

                  />
                ) : (
                  <Action
                    title={`Sell ${baseAsset}`}
                    priceSymbol={quoteAsset}
                    amountSymbol={baseAsset}
                    triggerPrice={triggerPrice}
                    conditionalOrOCO={conditionalOrOCO}
                    stop={stop}
                    limit={limit}
                    classButton="button-red"
                    buttonText={clientData?._id ? "Sell" : "Sign In"}
                    orders={orders}
                    type={type}
                    actionType='sell'
                    pricePrecision={pricePrecision}
                    amountPrecision={amountPrecision}
                    currentPrice={pricingData?.currentPrice}
                        klinesSymbol={klines?.symbol}

                  />
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.row}>
          <div className={styles.col}>
            <Action
              title={`Buy ${baseAsset}`}
              content={contentBuy}
              priceSymbol={quoteAsset}
              amountSymbol={baseAsset}
              triggerPrice={triggerPrice}
              conditionalOrOCO={conditionalOrOCO}
              stop={stop}
              limit={limit}
              classButton="button-green"
              buttonText={clientData?._id ? "Buy" : "Sign In"}
              takeProfit={takeProfit}
              stopLoss={stopLoss}
              orders={orders}
              type={type}
              actionType='buy'
              pricePrecision={pricePrecision}
              amountPrecision={amountPrecision}
              currentPrice={pricingData?.currentPrice}
                    klinesSymbol={klines?.symbol}

            />
          </div>
          <div className={styles.col}>
            <Action
              title={`Sell ${baseAsset}`}
              content={contentSell}
              priceSymbol={quoteAsset}
              amountSymbol={baseAsset}
              triggerPrice={triggerPrice}
              conditionalOrOCO={conditionalOrOCO}
              stop={stop}
              limit={limit}
              classButton="button-red"
              buttonText={clientData?._id ? "Sell" : "Sign In"}
              orders={orders}
              type={type}
              actionType='sell'
              pricePrecision={pricePrecision}
              amountPrecision={amountPrecision}
              currentPrice={pricingData?.currentPrice}
                              klinesSymbol={klines?.symbol}

            />
          </div>
        </div>
      )}
    </div>
  )
}

export default Form
